<template>
    <div class="RiskMannFooterAccesoDirecto">
        <div class="offcanvas offcanvas-bottom rounded" tabindex="-1" id="accesoDirectoFooter"
            aria-labelledby="accesoDirectoFooterLabel">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title fw-bold" id="accesoDirectoFooterLabel">Accesos Directos</h5>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div class="offcanvas-body justify-content-start mb-3 overflow-auto">
                <template v-if="idEmpresaSeleccionada === 'eeIA3a4jDGQ6m0thgGBS'">
                    <div class="card" @click="$refs['switch-conexion-footer'].seleccionarSwitch()">
                        <div class="card-body">
                            <SwitchConexion ref="switch-conexion-footer" />
                        </div>
                    </div>
                </template>
                <router-link :to="{ name: 'PlanesAccionActividades' }" class="text-decoration-none text-dark" :class="{
                    'cursor_none': esModoSinConexion
                }">
                    <div class="card" :class="{
                        'opacity': esModoSinConexion,
                        'mt-3': idEmpresaSeleccionada === 'eeIA3a4jDGQ6m0thgGBS'
                    }" data-bs-dismiss="offcanvas" aria-label="Close">
                        <div class="card-body d-flex align-items-center w-100">
                            <i class="fas fa-tasks text-primary"></i>
                            <p class="card-text">
                                Mis Actividades
                            </p>
                        </div>
                        <span v-if="actividades > 0" class="quantity_indicator rounded">
                            {{ actividades }}
                        </span>
                    </div>
                </router-link>
                <!-- <router-link :to="{ name: 'EmpresasMisEmpresas' }" class="text-decoration-none text-dark" :class="{
                    'cursor_none': esModoSinConexion
                }">
                    <div class="card mt-3" :class="{
                        'opacity': esModoSinConexion
                    }" data-bs-dismiss="offcanvas" aria-label="Close">
                        <div class="card-body d-flex align-items-center w-100">
                            <i class="fas fa-building text-primary"></i>
                            <p class="card-text">
                                Administrar Espacios de Trabajo
                            </p>
                        </div>
                    </div>
                </router-link> -->
                <router-link
                    :to="{ name: esModoSinConexion ? 'SeguridadVialInspeccionesOfflineNuevo' : 'SeguridadVialInspeccionesNuevo' }"
                    class="text-decoration-none text-dark">
                    <div class="card mt-3" data-bs-dismiss="offcanvas" aria-label="Close">
                        <div class="card-body d-flex align-items-center w-100">
                            <i class="fas fa-clipboard-check text-primary"></i>
                            <p class="card-text">
                                Nueva Inspección
                            </p>
                        </div>
                    </div>
                </router-link>
                <router-link
                    :to="{ name:'SeguridadVialMisInspecciones' }"
                    class="text-decoration-none text-dark">
                    <div class="card mt-3" data-bs-dismiss="offcanvas" aria-label="Close">
                        <div class="card-body d-flex align-items-center w-100">
                            <i class="fas fa-clipboard-list text-primary"></i>
                            <p class="card-text">
                                Mis Inspecciones
                            </p>
                        </div>
                    </div>
                </router-link>
                <router-link :to="{ name: 'SeguridadVialNovedadesNuevo' }" class="text-decoration-none text-dark"
                    :class="{ 'cursor_none': esModoSinConexion }">
                    <div class="card mt-3" :class="{ 'opacity': esModoSinConexion }" data-bs-dismiss="offcanvas"
                        aria-label="Close">
                        <div class="card-body d-flex align-items-center w-100">
                            <i class="fas fa-exclamation-circle text-primary"></i>
                            <p class="card-text">
                                Reportar Novedad
                            </p>
                        </div>
                    </div>
                </router-link>
                <router-link :to="{ name: 'SeguridadVialMantenimientosNuevo' }" class="text-decoration-none text-dark"
                    :class="{ 'cursor_none': esModoSinConexion }">
                    <div class="card mt-3" :class="{ 'opacity': esModoSinConexion }" data-bs-dismiss="offcanvas"
                        aria-label="Close">
                        <div class="card-body d-flex align-items-center w-100">
                            <i class="fas fa-car-battery text-primary"></i>
                            <p class="card-text">
                                Nuevo Mantenimiento
                            </p>
                        </div>
                    </div>
                </router-link>
                <router-link :to="{ name: 'SeguridadVialConductoresActivos' }" class="text-decoration-none text-dark"
                    :class="{ 'cursor_none': esModoSinConexion }">
                    <div class="card mt-3" :class="{ 'opacity': esModoSinConexion }" data-bs-dismiss="offcanvas"
                        aria-label="Close">
                        <div class="card-body d-flex align-items-center w-100">
                            <i class="fas fa-users text-primary"></i>
                            <p class="card-text">
                                Conductores
                            </p>
                        </div>
                    </div>
                </router-link>
                <router-link :to="{ name: 'SeguridadVialVehiculosActivos' }" class="text-decoration-none text-dark"
                    :class="{ 'cursor_none': esModoSinConexion }">
                    <div class="card mt-3" :class="{ 'opacity': esModoSinConexion }" data-bs-dismiss="offcanvas"
                        aria-label="Close">
                        <div class="card-body d-flex align-items-center w-100">
                            <i class="fas fa-car text-primary"></i>
                            <p class="card-text">
                                Vehículos
                            </p>
                        </div>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { auth } from "@/firebase";
import localforage from "localforage";
import SwitchConexion from "../SwitchConexion.vue";
export default {
    name: "RiskMannFooterAccesoDirecto",

    components: {
        SwitchConexion
    },

    data() {
        return {
            idEmpresaSeleccionada: "",
            actividades: 0,
            esModoSinConexion: false
        }
    },

    mounted() {
        document.getElementById('accesoDirectoFooter').addEventListener('hidden.bs.offcanvas', event => {
            this.$emit("mostrar", false);
        })
    },

    async created() {
        this.esModoSinConexion = await this.$store.state.obtenerModoSinConexion();
        if (this.esModoSinConexion) {
            const usuarioLocal = await localforage.getItem(this.$store.state.colecciones.localforage.usuarios.local);
            if (usuarioLocal) {
                this.idEmpresaSeleccionada = usuarioLocal.preferencias.idEmpresaSeleccionada;
            }
        } else {
            const usuario = auth.currentUser;
            if (usuario) {
                const usuarioDB = await this.$store.state.obtenerUsuario(usuario.uid);
                if (usuarioDB) {
                    this.idEmpresaSeleccionada = usuarioDB.preferencias.idEmpresaSeleccionada;
                    this.actividades = await this.$store.state.planAccion.actividad.funciones.obtenerCantidadResponsable(usuarioDB.preferencias.idEmpresaSeleccionada, auth.currentUser.uid);
                }
            }
        }
    },
}
</script>

<style scoped>
.offcanvas-bottom {
    height: 500px;
}

.offcanvas-body {
    overflow-y: hidden;
}

.card {
    background-color: #f3f3f3;
}

.card:hover {
    cursor: pointer;
    transition-duration: 1s;
    box-shadow: none !important;
    border: solid 1px #073d7a !important;
}

.opacity {
    opacity: 0.6;
}

.cursor_none {
    pointer-events: none;
}

.fas.fa-building {
    font-size: 16pt;
    margin-right: 14px;
    margin-left: 5px;
}

.fas.fa-users {
    font-size: 14pt;
    margin-right: 10px;
    margin-left: 0px;
}

.fas.fa-car {
    font-size: 16pt;
    margin-right: 11px;
    margin-left: 0px;
}

.fas.fa-clipboard-check {
    font-size: 16pt;
    margin-right: 14px;
    margin-left: 5px;
}

.fas.fa-clipboard-list {
    font-size: 16pt;
    margin-right: 14px;
    margin-left: 5px;
}

.fas.fa-exclamation-circle {
    font-size: 14pt;
    margin-right: 10px;
    margin-left: 4px;
}

.fas.fa-car-battery {
    font-size: 16pt;
    margin-right: 11px;
    margin-left: 2px;
}

.fas.fa-tasks {
    font-size: 16pt;
    margin-right: 11px;
    margin-left: 2px;
}

.quantity_indicator {
    position: absolute;
    top: -10px;
    right: -10px;
    background-color: #E6423C;
    color: white;
    padding: 5px 10px;
    font-size: 12px;
    font-weight: bold;
}
</style>
